import { render, staticRenderFns } from "./ReceptionDetailDiseaseEditor.vue?vue&type=template&id=5341090b&scoped=true&"
import script from "./ReceptionDetailDiseaseEditor.vue?vue&type=script&lang=ts&"
export * from "./ReceptionDetailDiseaseEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ReceptionDetailDiseaseEditor.vue?vue&type=style&index=0&id=5341090b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5341090b",
  null
  
)

export default component.exports